import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

interface Props {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  descriptionLineHeight?: string;
}

const CardActionCardHeader: React.FC<Props> = ({
  icon,
  title,
  description,
  descriptionLineHeight = '22px',
}) => (
  <Box align="center" margin={{ bottom: 'spacing16' }}>
    {icon}
    <Inscription
      color="textBody"
      weight="bold"
      margin={{ top: 'spacing16', bottom: 'spacing8' }}
      lineHeight="20px"
    >
      {title}
    </Inscription>
    <Inscription
      color="textBody"
      textAlign="center"
      lineHeight={descriptionLineHeight}
    >
      {description}
    </Inscription>
  </Box>
);

export default CardActionCardHeader;
